import {
  LANG_DE_TRANS,
  LANG_DE_AGREEMENT_TRANS,
  LANG_DE_CONSUMPTIONS_TRANS,
  LANG_DE_CONTRACT_TRANS,
  LANG_DE_CONTRACT_BANK_ACCOUNT_DETAILS_TRANS,
  LANG_DE_CONTRACT_CONTACT_DETAILS_TRANS,
  LANG_DE_CONTRACT_CONTACT_PERSONS_TRANS,
  LANG_DE_CONTRACT_CONTRACT_DETAILS_TRANS,
  LANG_DE_CONTRACT_RENT_DETAILS_TRANS,
  LANG_DE_CONTRACT_REQUEST_DOCUMENTS_TRANS,
  LANG_DE_ISSUES_TRANS,
  LANG_DE_LOGOUT_TRANS,
  LANG_DE_NEWS_TRANS,
  LANG_DE_START_TRANS,
  LANG_DE_SURVEY_TRANS,
  LANG_DE_REGISTRATION_TRANS,
  LANG_DE_REQUESTPASSWORD_TRANS,
  LANG_DE_UNLOCK_TRANS,
  LANG_DE_VERIFYEMAIL_TRANS,
  LANG_DE_SETEMAIL_TRANS,
  LANG_DE_SETPASSWORD_TRANS,
  LANG_DE_FAQ_TRANS,
  LANG_DE_ISSUE_DETAILS_TRANS,
  LANG_DE_DOORS_TRANS,
  LANG_DE_SERVICE_CENTER_TRANS,
  LANG_DE_ERROR_TRANS,
  LANG_DE_MOBILITY_STATION_TRANS,
  LANG_DE_DOCUMENTS_TRANS,
  LANG_DE_DOWNLOAD_DOCUMENTS_TRANS,
  LANG_DE_PIN_TRANS,
  LANG_DE_CONTRACT_BANK_ACCOUNT_BALANCE_TRANS,
  LANG_DE_COMPARE_EMAIL_TRANS,
  LANG_DE_LOGINWITHOUTREGISTRATION_CONNECTCONTRACT_TRANS,
  LANG_DE_LOGINWITHOUTREGISTRATION_REQUESTPIN_TRANS,
  LANG_DE_LOGINWITHOUTREGISTRATION_PINREQUESTED_TRANS,
  LANG_DE_LOGINWITHOUTREGISTRATION_ENTERPIN_TRANS,
  LANG_DE_LOGINWITHOUTREGISTRATION_USERREJECTED_TRANS,
  LANG_DE_REGISTRATION_COMPLETED_TRANS,
  LANG_DE_REGISTRATION_CREATEACCOUNT_TRANS,
  LANG_DE_PUBLIC_WELCOME_TRANS,
  LANG_DE_PUBLIC_CONNECTCONTRACT_TRANS,
  LANG_DE_PUBLIC_REQUESTPIN_TRANS,
  LANG_DE_PUBLIC_USERREJECTED_TRANS,
  LANG_DE_PUBLIC_CONNECTCONTRACTFAILED_TRANS,
  LANG_DE_PUBLIC_ENTERPIN_TRANS,
  LANG_DE_CHAT_TRANS,
  LANG_DE_MIGRATION_TRANS,
  LANG_DE_LPA_START_TRANS,
  LANG_DE_LPA_PIN_TRANS,
  LANG_DE_LPA_CONTRACTNUMBER_TRANS,
  LANG_DE_LPA_DATE_TRANS,
  LANG_DE_LPA_ERROR_TRANS,
  LANG_DE_LPA_CONSENTMANAGEMENT_TRANS,
  LANG_DE_PUBLIC_SURVEY_TRANS,
  LANG_DE_MARKETPLACE_TRANS,
} from './de';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { LANG_DE_SC } from 'libs/web-components/src/lib/single-consent/_translations/de';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { LANG_DE_D2_LIST } from 'libs/web-components/src/lib/documents2/_translations/de';

// @TODO: could not find a solution for this, so we run eslint-disable-next-line for the rule here
// will become obsolet once translationService is replaced with dictionaryService
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  LANG_DE_CONSENTMANAGEMENT,
  LANG_DE_COUNTRY_CODES,
  LANG_DE_CM_THANKYOU,
  LANG_DE_CM_CONFIRM_EMAIL_PIN,
  LANG_DE_CM_CONFIRM_DELETE,
} from '@mono-repo/wc-consentmanagement';

export const dictionary = {
  de: LANG_DE_TRANS,
  de_agreements: LANG_DE_AGREEMENT_TRANS,
  de_chat: LANG_DE_CHAT_TRANS,
  de_compareEmail: LANG_DE_COMPARE_EMAIL_TRANS,
  de_consumptions: LANG_DE_CONSUMPTIONS_TRANS,
  de_contract: LANG_DE_CONTRACT_TRANS,
  de_contract_bankAccountDetails: LANG_DE_CONTRACT_BANK_ACCOUNT_DETAILS_TRANS,
  de_contract_bankAccountBalance: LANG_DE_CONTRACT_BANK_ACCOUNT_BALANCE_TRANS,
  de_contract_contactDetails: LANG_DE_CONTRACT_CONTACT_DETAILS_TRANS,
  de_contract_contactPersons: LANG_DE_CONTRACT_CONTACT_PERSONS_TRANS,
  de_contract_contractDetails: LANG_DE_CONTRACT_CONTRACT_DETAILS_TRANS,
  de_contract_rentDetails: LANG_DE_CONTRACT_RENT_DETAILS_TRANS,
  de_contract_requestDocuments: LANG_DE_CONTRACT_REQUEST_DOCUMENTS_TRANS,
  de_documents: LANG_DE_DOCUMENTS_TRANS,
  de_download_documents: LANG_DE_DOWNLOAD_DOCUMENTS_TRANS,
  de_doors: LANG_DE_DOORS_TRANS,
  de_error: LANG_DE_ERROR_TRANS,
  de_faq: LANG_DE_FAQ_TRANS,
  de_issues: LANG_DE_ISSUES_TRANS,
  de_issue_details: LANG_DE_ISSUE_DETAILS_TRANS,
  de_logout: LANG_DE_LOGOUT_TRANS,
  de_marketplace: LANG_DE_MARKETPLACE_TRANS,
  de_migration: LANG_DE_MIGRATION_TRANS,
  de_mobilityStation: LANG_DE_MOBILITY_STATION_TRANS,
  de_news: LANG_DE_NEWS_TRANS,
  de_pin: LANG_DE_PIN_TRANS,
  de_registration: LANG_DE_REGISTRATION_TRANS,
  de_registration_completed: LANG_DE_REGISTRATION_COMPLETED_TRANS,
  de_registration_createAccount: LANG_DE_REGISTRATION_CREATEACCOUNT_TRANS,
  de_public_welcome: LANG_DE_PUBLIC_WELCOME_TRANS,
  de_public_connectContract: LANG_DE_PUBLIC_CONNECTCONTRACT_TRANS,
  de_public_connectContractFailed: LANG_DE_PUBLIC_CONNECTCONTRACTFAILED_TRANS,
  de_public_requestPin: LANG_DE_PUBLIC_REQUESTPIN_TRANS,
  de_public_enterPin: LANG_DE_PUBLIC_ENTERPIN_TRANS,
  de_public_userRejected: LANG_DE_PUBLIC_USERREJECTED_TRANS,
  de_public_survey: LANG_DE_PUBLIC_SURVEY_TRANS,
  de_loginWithoutRegistration_connectContract: LANG_DE_LOGINWITHOUTREGISTRATION_CONNECTCONTRACT_TRANS,
  de_loginWithoutRegistration_requestPin: LANG_DE_LOGINWITHOUTREGISTRATION_REQUESTPIN_TRANS,
  de_loginWithoutRegistration_pinRequested: LANG_DE_LOGINWITHOUTREGISTRATION_PINREQUESTED_TRANS,
  de_loginWithoutRegistration_enterPin: LANG_DE_LOGINWITHOUTREGISTRATION_ENTERPIN_TRANS,
  de_loginWithoutRegistration_userRejected: LANG_DE_LOGINWITHOUTREGISTRATION_USERREJECTED_TRANS,
  de_requestPassword: LANG_DE_REQUESTPASSWORD_TRANS,
  de_servicecenter: LANG_DE_SERVICE_CENTER_TRANS,
  de_setEmail: LANG_DE_SETEMAIL_TRANS,
  de_setPassword: LANG_DE_SETPASSWORD_TRANS,
  de_start: LANG_DE_START_TRANS,
  de_survey: LANG_DE_SURVEY_TRANS,
  de_unlock: LANG_DE_UNLOCK_TRANS,
  de_verifyEmail: LANG_DE_VERIFYEMAIL_TRANS,
  de_lpa_start: LANG_DE_LPA_START_TRANS,
  de_lpa_pin: LANG_DE_LPA_PIN_TRANS,
  de_lpa_contractnumber: LANG_DE_LPA_CONTRACTNUMBER_TRANS,
  de_lpa_date: LANG_DE_LPA_DATE_TRANS,
  de_lpa_error: LANG_DE_LPA_ERROR_TRANS,
  de_lpa_consentmanagement: LANG_DE_LPA_CONSENTMANAGEMENT_TRANS,
  de_consentmanagement: LANG_DE_CONSENTMANAGEMENT,
  de_cm_confirm_email_pin: LANG_DE_CM_CONFIRM_EMAIL_PIN,
  de_cm_confirm_delete: LANG_DE_CM_CONFIRM_DELETE,
  de_country_codes: LANG_DE_COUNTRY_CODES,
  de_cm_thankyou: LANG_DE_CM_THANKYOU,
  de_d2_list: LANG_DE_D2_LIST,
  de_sc: LANG_DE_SC,
};
